import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import TableContainer from '../../../Components/Common/TableContainer';
import {
    Type,
    Quantity,
    OrderValue,
    AvgPrice,
    Price,
    Status
} from './OrderCol';
import { deleteOrder } from '../../../utils/order';

const AllManageOrders = ({ orderList, total = 0, currentPage = 1, pageSize = 8, onChange }) => {
    
 

    const onClickDelete = async (id) => {
        try {
           
          // Make API call with error handling
          const response = await deleteOrder(id);
          
          // Check if response exists and has expected structure 
          // Handle successful response
          if (response.status==200) {
            successnotify("Order delete successfully");
            navigate('/order-list'); 
          } else {
            // Handle API error with message
              errornotify(response.data.message || "Failed to delete Order . Please try again.")  
          }
      
        } catch (err) {
          console.error('Submission failed:', err);
          errornotify(err.response?.message || 
            err.message || 
            'Failed to delete Order . Please check your connection and try again.')  
          
        }
    }
    const columns = useMemo(
        () => [
            {
                header: "orderId",
                accessorKey: "order_reference_id",
                enableColumnFilter: false,
                cell: (cell) => (
                    <>
                    <div className="d-flex align-items-center"> 
                        <Link to={"/order-detail?orderId="+cell.row.original.id} className="currency_name flex-grow-1 ms-2">{cell.getValue()}</Link>
                    </div>
                </>
                ),
            },
            {
                header: "created_at",
                accessorKey: "created_at",
                enableColumnFilter: false,
                cell: (cell) => ( 
                    <>
                        {cell.getValue()}{" "}
                        <small className="text-muted">{cell.row.original.time}</small>
                    </>
                ),
            },
            {
                header: "discount",
                accessorKey: "discount",
                enableColumnFilter: false,
                cell: (cell) => {
                    return <Type {...cell} />;
                },
            },
            {
                header: "shipping Charge",
                accessorKey: "c",
                enableColumnFilter: false,
                cell: (cell) => {
                    return <Quantity {...cell} />;
                },
            },
            {
                header: "Tax",
                accessorKey: "tax",
                enableColumnFilter: false,
                cell: (cell) => {
                    return <OrderValue {...cell} />;
                },
            },
            {
                header: "Total",
                accessorKey: "total_price",
                enableColumnFilter: false,
                cell: (cell) => {
                    return <AvgPrice {...cell} />;
                },
            }, 
            {
                header: "Status",
                accessorKey: "status",
                enableColumnFilter: false,
                cell: (cell) => {
                    return <Status {...cell} />;
                },
            },
            {
                header: "Actions",
                accessorKey: "status",
                enableColumnFilter: false,
                cell: (cell) => {
                    return (
                        <div className="d-flex gap-3">  
                          <Link
                           to={"/order-add?orderId="+cell.row.original.id}   
                            className="text-success"
                          >
                            <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                            <UncontrolledTooltip placement="top" target="edittooltip">
                              Edit
                            </UncontrolledTooltip>
                          </Link>
                          <Link
                            to="#"
                            className="text-danger"
                            onClick={() => {
                              const orderData = cell.row.original.id;
                              onClickDelete(orderData);
                            }}
                          >
                            <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                            <UncontrolledTooltip placement="top" target="deletetooltip">
                              Delete
                            </UncontrolledTooltip>
                          </Link>
                        </div>
                      );
                },
            },
        ],
        []
    );
    return (
        <React.Fragment>
            <Col lg={12}>
                <Card>
                    <CardHeader className="d-flex align-items-center border-0">
                        <h5 className="card-title mb-0 flex-grow-1">All Orders</h5>
                        
                    </CardHeader>
                    <CardBody>
                        <TableContainer
                            columns={columns}
                            data={(orderList || [])}
                            total={total || (orderList || []).length}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onChange={onChange}
                            isGlobalFilter={true}
                            isAddUserList={false}
                            customPageSize={pageSize}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-1"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light text-muted"
                            isCryptoOrdersFilter={true}
                            SearchPlaceholder='Search for orders'
                        />
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default AllManageOrders;